import React from 'react';
import Helmet from 'react-helmet';
import Link from 'gatsby-link';

import styled from 'styled-components';
import _ from 'lodash';

// Utils
import { createSlugFromTitle } from '../utils';
import { backgroundTheme, media } from '../styles/style-utils';

const PageWrapper = styled.section``;

const NutrientsWrapper = styled.section`
  padding: 2rem 0 0;
`;

const NutrientsList = styled.ul`
  vertical-align: top;
  margin: 0 0 4rem;
  > li {
    width: 100px;
    margin: 0 10px 50px 10px;
    padding: 10px;
    list-style-type: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    
    > a {
      display: block;
      padding: 1rem;
      border: 1px solid black;
    }
  }
`;

const HeaderSection = styled.section`
  padding: 2rem 1rem;
  margin: 5rem 0 4rem 0;
  position: relative;
`;

const BackLinkWrap = styled.div`
  position: absolute;
  display: block;
  width: 100px;
  font-size: 2rem;
  line-height: 2rem;
  padding: 1rem;
  top: -5rem;
  left: 0;
  border-bottom: 1px solid black;

  > a {
    color: black;
  }
`;

const AllNutrientsPage = ({ data }) => {

  const filteredNodes = _.sortBy(
    data.allMarkdownRemark.edges
    .filter(({ node }) => node.frontmatter.type === 'nutrient')
    .map(({ node }) => node)
  , node => node.frontmatter.name);

  return (
    <PageWrapper>
      <Helmet>
        <title>Nutrients & Vitamins</title>
      </Helmet>
      <HeaderSection>
        <h1>Nutrients & Vitamins</h1>
        <p>Find out what these things do to keep you healthy, and which foods you can find them in.</p>
        <BackLinkWrap>
          <Link to='/'>&larr; Home</Link>
        </BackLinkWrap>
      </HeaderSection>
      <NutrientsWrapper>
        <NutrientsList>
          {filteredNodes.map(node => <li key={node.frontmatter.name}><Link to={node.frontmatter.path}>{node.frontmatter.name}</Link></li>)}
        </NutrientsList>
      </NutrientsWrapper>
    </PageWrapper>
  );
};

export const query = graphql`
  query NutrientsQuery {
    allMarkdownRemark {
      edges {
        node {
          id
          frontmatter {
            path
            name
            altname
            tags
            type
          }
        }
      }
    }
  }
`;

export default AllNutrientsPage;



// WEBPACK FOOTER //
// ./src/pages/nutrients.js